import { SystemTypeOption } from './recommendations-strip-logic';
import {
  arePicksEmpty,
  buildCompositionIndex,
  picksForSystemTypeId
} from './system-composition';
import { CompositionPicks } from './system-composition-types';

export function compositionPicksForSavedWant(
  systemTypes: SystemTypeOption[] | null | undefined,
  wantIds: number[] | null | undefined
): CompositionPicks | null {
  const wantId = wantIds?.[0];
  if (wantId === undefined || !systemTypes?.length) return null;
  const picks = picksForSystemTypeId(
    wantId,
    buildCompositionIndex(systemTypes)
  );
  return arePicksEmpty(picks) ? null : picks;
}

export function compositionPicksToHydrate(
  existing: CompositionPicks | undefined,
  systemTypes: SystemTypeOption[] | null | undefined,
  wantIds: number[] | null | undefined
): CompositionPicks | null {
  if (existing && !arePicksEmpty(existing)) return null;
  return compositionPicksForSavedWant(systemTypes, wantIds);
}
